import { Configuration } from '@azure/msal-browser';
import * as config from '../../../Config';

export const generateMsalConfig = (): Configuration => {
  return {
    auth: {
      clientId: config.clientId,
      authority: config.authorityUrl,
      redirectUri: config.redirectUri,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };
};

export const loginRequest = {
  scopes: config.scopeBase,
};
